module.exports = __webpack_public_path__ + "static/media/(V)_MG_4919_-_bijuterias.1ba575b9.jpg";